import DefaultPage from './default-page';


class OverlayPage extends DefaultPage {


}

export default OverlayPage;
